// 2025(c) ESIEE Paris
// Author: CANDIA Nicolas <nicolas.candia@esiee.fr>


export class TableTreeview 
{
    constructor(rootElement, init = true)
    {
        this.root = rootElement;
        this.nodes = {};
        this.tree = [];

        this.build_tree();

        if (init) {
            this.transform_table();
        }
    }

    build_tree() 
    {
        const self = this;
        this.root.querySelectorAll("tr[data-treenode]").forEach(function(node) {
            self.nodes[node.dataset.treenode] = {
                'el': node,
                'parent': null,
                'children': []
            };
        });

        for (const treenode in this.nodes) {
            const parent_node = this.nodes[treenode]['el'].dataset.treenodeParent;
            if (parent_node != undefined && parent_node != '-1' && this.nodes[parent_node] !== undefined) {
                this.nodes[treenode]['parent'] = this.nodes[parent_node];
                this.nodes[parent_node]['children'].push(this.nodes[treenode]);
            } else {
                this.tree.push(this.nodes[treenode]);
            }
        }
    }

    transform_table()
    {
        const self = this;

        let stack = [];
        for (let i = 0; i < this.tree.length; ++i) {
            stack.push([this.tree[i], 0]);
        }

        while (stack.length > 0)
        {
            const [node, level] = stack.pop();

            const td = node['el'].querySelector('td');
            if (td !== undefined) {
                // Add expand button if node has children
                if (node['children'].length > 0)
                {
                    const button = this._createToggleButton(td, node['el'], level);

                    button.addEventListener("click", function(event) {
                        const treenode = node['el'].dataset.treenode;

                        self.displayNode(node, (node['el'].dataset.treenodeState != 'show'));

                        const btn = self.root.querySelector("button[data-treenode-toggle='" + treenode + "']");
                        self._setToggleButton(btn, node['el'].dataset.treenodeState);
                    });
                }

                // Adds spacers
                this._insertSpacer(td, level);
            }

            // Continue tree exploration
            for (let i = 0; i < node['children'].length; ++i)
            {
                const child = node['children'][i];

                // Hide children by default
                if (node['el'].dataset.treenodeState != 'show') {
                    child['el'].classList.add('d-none');
                }

                stack.push([child, level + 1]);
            }
        }
    }

    displayNode(node, state)
    {
        node['el'].dataset.treenodeState = (state) ? "show" : "hidden";

        let stack = [];
        for (let i = 0; i < node['children'].length; ++i) {
            stack.push([node['children'][i], state]);
        }

        while (stack.length > 0)
        {
            const [child, child_state] = stack.pop();

            if (child_state)
            {
                child['el'].classList.remove('d-none');

                const next_state = child['el'].dataset.treenodeState == "show";

                for (let i = 0; i < child['children'].length; ++i) {
                    stack.push([child['children'][i], next_state]);
                }
            }
            else
            {
                child['el'].classList.add('d-none');

                for (let i = 0; i < child['children'].length; ++i) {
                    stack.push([child['children'][i], false]);
                }
            }

            
        }
    }

    _createToggleButton(parent, node)
    {
        const button = document.createElement("button");
        button.classList.add('treenode-toggle');
        button.dataset.treenodeToggle = node.dataset.treenode;
        this._setToggleButton(button, node.dataset.treenodeState);
        return parent.insertBefore(button, parent.firstChild);
    }

    _setToggleButton(button, state)
    {
        if (state == "show" || state === true) {
            button.innerHTML = '<span class="material-icons">arrow_drop_down</span>';
        } else {
            button.innerHTML = '<span class="material-icons">arrow_right</span>';
        }
    }

    _insertSpacer(element, level)
    {
        for (let i = 0; i < level; ++i) {
            const spacer = document.createElement('span');
            spacer.classList.add('spacer');
            element.insertBefore(spacer, element.firstChild);
        }
    }

}